import { IWidgetConfigComponentProps } from '@framework/engine';
import { FormItem, SelectInput } from '@framework/form';
import { Typography } from 'antd';
import * as React from 'react';
import { useMemo } from 'react';
import { ApplicantDataTypes } from './ApplicantDataTypes';
import { CompanyApplicantDataTypes } from './CompanyApplicantData';

export interface IApplicantDataDirectiveConfigComponent
  extends IWidgetConfigComponentProps {}

/**
 * Campo di input per indicare in che campo della tabella salvare il valore.
 */
export function ApplicantDataDirectiveConfigComponent(
  props: IApplicantDataDirectiveConfigComponent,
) {
  const { name, widget, widgetType } = props;

  const availableAttributes = useMemo(() => {
    // const datatype = widgetType.getReference?.([], widget)?.field.type;
    return ApplicantDataTypes.List.concat(CompanyApplicantDataTypes.List).map(
      type => ({
        value: type.code,
        searchable: type.label + ' ' + type.description,
        label: (
          <>
            {type.label}{' '}
            {type.description && (
              <Typography.Text type="secondary">
                {type.description}
              </Typography.Text>
            )}
          </>
        ),
      }),
    );
  }, []);

  return (
    <FormItem
      name={`${props.name}.name`}
      label="Attributo del titolare della richiesta"
      help="Indica che il valore di questo campo sarà trattato come attributo del titolare della richiesta, ad esempio è il Nome del Titolare"
      style={{ marginBottom: 48 }}
    >
      <SelectInput
        name={`${props.name}.code`}
        optionFilterProp="searchable"
        options={availableAttributes}
        allowClear
        placeholder="Seleziona attributo..."
        searchable
      />
    </FormItem>
  );
}
